import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import NRTooltipContent from '../NRTooltipContent/NRTooltipContent';

const NRTag = ({ text, tooltipContent, style, isScope, actualScope }) => {
  const theme = useTheme();

  const getTooltipContent = () => {
    const content = [];

    if (tooltipContent) {
      content.push(tooltipContent);
    }

    if (isScope) {
      if (actualScope) {
        content.push(
          <>
            <Box component="span" sx={{ fontWeight: 700 }}>
              Actual Scope:{' '}
            </Box>
            {actualScope}
          </>
        );
      }

      content.push(
        <>
          <Box component="span" sx={{ fontWeight: 700 }}>
            Dependent Scope:{' '}
          </Box>
          The scope through which this component was introduced into the asset by one or more dependent components, based on package metadata.
        </>
      );

      content.push(
        <>
          <Box component="span" sx={{ fontWeight: 700 }}>
            Note:{' '}
          </Box>
          This reflects direct dependency links only. It does not account for transitive inheritance.
        </>
      );
    }

    return content;
  };

  const content = (
    <Box
      sx={{
        display: 'flex',
        padding: theme.spacing(0.5, 1),
        alignItems: 'center',
        gap: theme.spacing(0.5),
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${theme.palette?.neutral?.[400] || theme.palette.divider}`,
        whiteSpace: 'nowrap',
        cursor: 'default',
        height: 24,
        boxSizing: 'border-box',
        ...style
      }}
    >
      <Typography variant="caption" color="textSecondary">
        {text}
      </Typography>
    </Box>
  );

  if (tooltipContent || isScope) {
    return (
      <Tooltip
        title={<NRTooltipContent title={text} content={getTooltipContent()} />}
        placement="top"
        slotProps={{
          tooltip: {
            sx: {
              padding: theme.spacing(1, 1.5),
              backgroundColor: 'tooltip.background',
              borderRadius: theme.spacing(0.5),
              maxWidth: 300,
              overflow: 'visible'
            }
          }
        }}
      >
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default NRTag;
